export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "search.worker-f29a7d129b33ee364c41.worker.js");
}
